import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function LifestyleBanner() {
  return (
    <section className="relative h-[90vh] min-h-[650px] overflow-hidden">

      {/* Background Image */}

      <img
        src="/images/lifestyle-banner.jpg"
        alt="Lifestyle"
        // className="absolute inset-0 h-full w-full object-cover"
         className="absolute inset-0 h-full w-full object-cover scale-105 transition duration-[8000ms] hover:scale-110"
      />

      {/* Dark Overlay */}

      <div className="absolute inset-0 bg-black/45" />

      {/* Gradient */}

      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent" />

      {/* Content */}

      <div className="relative z-10 mx-auto flex h-full max-w-7xl items-center px-6">

        <div className="max-w-2xl text-white">

          <span className="uppercase tracking-[5px] text-[#C6D5B9]">
            A Better Everyday
          </span>

          <h2 className="mt-6 text-5xl font-semibold leading-tight md:text-7xl">
            Objects Worth
            <br />
            Living With.
          </h2>

          <p className="mt-8 max-w-xl text-lg leading-8 text-gray-200">
            Every cup, every page, every plant, and every object in our
            collection is chosen to slow you down and enrich your daily
            rituals.
          </p>

          <div className="mt-12 flex flex-wrap gap-5">

            <Link
              to="/shop"
              className="rounded-full bg-[#6B8E5F] px-8 py-4 font-medium text-white transition hover:bg-[#557149]"
            >
              Shop Collection
            </Link>

            <Link
              to="/journal"
              className="flex items-center gap-2 rounded-full border border-white/30 px-8 py-4 font-medium text-white backdrop-blur-sm transition hover:bg-white hover:text-black"
            >
              Read Our Journal
              <ArrowRight size={18}/>
            </Link>

          </div>

        </div>

      </div>

    </section>
  );
}